module.exports = __webpack_public_path__ + "img/ic_euro.ac784e0e.svg";